module.exports = __webpack_public_path__ + "static/img/fingerbutton2.54aa557.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fingerbutton2.png
// module id = N+ur
// module chunks = 1